module.exports = __webpack_public_path__ + "img/1533543682.dec6ae7d.jpg";